import { type IService, ServiceFormats, ServiceSeatsPaymentTypes, ServiceTypes } from '@types';
import { AdditionalPriceOptions } from './additionalTypes';

const toNumber = (val: any): number => +val || 0;

export function getSeatsData(service: IService = {}) {
  let min = 1;
  let max = Infinity;
  let includedSeats = 0;
  let additionalSeats = 0;
  let pricePerSeat = 0;

  switch (service.type) {
    case ServiceTypes.Rent: {
      max = toNumber(service.seats);

      if (service.format === ServiceFormats.timeAndPlace) {
        includedSeats = toNumber(service.includedSeats);
        additionalSeats = toNumber(service.additionalSeats);
        max = Math.min(max, includedSeats + additionalSeats);
        pricePerSeat = toNumber(service.additionalSeatsAmount);
      }
      break
    }

    case ServiceTypes.GroupService: {
      max = toNumber(service.seats) || 1;
      break;
    }

    case ServiceTypes.Individual: {
      min = toNumber(service.amountPeopleMin);
      max = toNumber(service.amountPeopleMax);
      break;
    }
  }

  if (max < 1) max = 1;

  function getSeatPrice(duration = 0) {
    switch (service.additionalSeatsPaymentType) {
      case ServiceSeatsPaymentTypes.Time: return pricePerSeat * (duration / 60);
      default: return pricePerSeat;
    }
  }

  function computeAdditionalSeatsPrice({ count = 1, duration = 0 }: AdditionalPriceOptions) {
    if (!count) return 0;
    const extraCount = Math.max(0, count - includedSeats);
    return extraCount * getSeatPrice(duration);
  }

  return {
    min,
    max,
    includedSeats,
    computeAdditionalSeatsPrice
  }
}